import { render, staticRenderFns } from "./HelpAdd.vue?vue&type=template&id=e73ef1a6&"
import script from "./HelpAdd.vue?vue&type=script&lang=js&"
export * from "./HelpAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports